import { render, staticRenderFns } from "./preview_details.vue?vue&type=template&id=568dd83a&"
import script from "./preview_details.vue?vue&type=script&lang=js&"
export * from "./preview_details.vue?vue&type=script&lang=js&"
import style0 from "./preview_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports